import { render, staticRenderFns } from "./LandingV2.vue?vue&type=template&id=661d54d0&scoped=true&"
import script from "./LandingV2.vue?vue&type=script&lang=js&"
export * from "./LandingV2.vue?vue&type=script&lang=js&"
import style0 from "./LandingV2.vue?vue&type=style&index=0&id=661d54d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d54d0",
  null
  
)

export default component.exports